import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { MatIconAnchor, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

import { BaasAppState, BaasAuthService } from '@lvflanders/bar';
import { BaasClickOutsideBehavior, BarI18nPipe } from '@lvflanders/bar-ng-ui';

import { StartschermV2FormatteerInternalService } from '../../services/v2/startscherm-v2-formatteer-internal.service';
import { StartschermV2StateService } from '../../services/v2/startscherm-v2-state.service';
import { StartschermOmgevingen } from '../startscherm-omgevingen-widget/startscherm-omgevingen-widget';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'startscherm-user-widget',
    templateUrl: './startscherm-user-widget.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasClickOutsideBehavior, MatIconAnchor, MatTooltip, MatIconButton, MatIcon, StartschermOmgevingen, BarI18nPipe]
})
export class StartschermUserWidget {
    readonly state = inject(StartschermV2StateService);
    readonly #appState = inject(BaasAppState);
    readonly #barAuthService = inject(BaasAuthService);
    readonly #startschermV2FormatteerInternalService = inject(StartschermV2FormatteerInternalService);

    readonly compact = model.required<boolean>();
    // NOTE next variables only assigned in ngOnInit, so no need for signals
    protected abbreviatedName = this.#appState.basiscontext.fullUsername;
    protected isVisible = this.state.isIntern || this.state.isExtern;
    protected name = this.#appState.basiscontext.fullUsername;
    protected clientNumber = this.#appState.basiscontext.klantnummer;
    protected parsedClientNumber = this.#startschermV2FormatteerInternalService.formatteerKlantnummer(this.#appState.basiscontext.klantnummer);

    protected toggleCompact(event: Event): void {
        event.preventDefault();
        this.compact.set(!this.compact());
    }

    protected async logout() {
        await this.#barAuthService.logOff();
    }

    protected copyClientNumber() {
        /* this is a promise, which we do not handle. Just return it */
        return (navigator as any).clipboard.writeText(this.clientNumber);
    }
}
